export default __webpack_public_path__ + "static/media/Inventory-icon.405c80d9.svg";